import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import TextField from '@mui/material/TextField'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const TextFieldInput = ({ name, rowData, errorData, id, field, setValue, register, getValues }) => {
  const { t } = useTranslation()
  const initialValueTextField = {
    id,
    available_codes: rowData.available_codes,
    limit_min: rowData.limit_min,
    limit_max: rowData.limit_max,
    type: rowData.type,
  }

  useEffect(() => {
    getValues(id) === undefined && setValue(id, { ...initialValueTextField, amount_codes: '', point: '' })
  }, [])
  switch (field) {
    case 'amount_codes':
      return (
        <TextField
          fullWidth
          disabled={VOUCHER_TYPE.STANDARD === rowData.type}
          name={name}
          size="small"
          type="number"
          variant="outlined"
          {...register(name)}
          error={errorData[id]?.error}
          helperText={
            errorData[id]?.error &&
            t(errorData[id]?.errorMessage.message, {
              min: errorData[id]?.errorMessage.min,
              max: errorData[id]?.errorMessage.max,
            })
          }
          onChange={(event) => {
            const value = {
              ...initialValueTextField,
              amount_codes: event.target.value,
              point: getValues(id)?.point ?? 0,
            }
            setValue(id, value)
            setValue(name, event.target.value)
          }}
        />
      )
    case 'point':
      return (
        <TextField
          fullWidth
          name={`${id}_point`}
          size="small"
          type="number"
          {...register(name)}
          error={errorData[id]?.errorPoint}
          helperText={
            errorData[id]?.errorPoint &&
            t(errorData[id]?.errorPointMessage.message, {
              number: errorData[id]?.errorPointMessage.number,
            })
          }
          variant="outlined"
          onChange={(event) => {
            const value = {
              ...initialValueTextField,
              amount_codes: getValues(id)?.amount_codes ?? 0,
              point: event.target.value,
            }
            setValue(id, value)
            setValue(name, event.target.value)
          }}
        />
      )

    default:
      return null
  }
}

export default TextFieldInput
